var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.31875 4.05L8.66875 6H4C1.79375 6 0 7.79375 0 10V26C0 28.2062 1.79375 30 4 30H28C30.2062 30 32 28.2062 32 26V10C32 7.79375 30.2062 6 28 6H23.3312L22.6812 4.05C22.275 2.825 21.1313 2 19.8375 2H12.1625C10.8688 2 9.725 2.825 9.31875 4.05ZM16 24C12.6875 24 10 21.3125 10 18C10 14.6875 12.6875 12 16 12C19.3125 12 22 14.6875 22 18C22 21.3125 19.3125 24 16 24Z",
    fill: "#3F69FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.40bea434da1b43e8002f29b5efa9a67f.svg";
export { ForwardRef as ReactComponent };